import { render, staticRenderFns } from "./CatPick.vue?vue&type=template&id=617065b6&scoped=true&"
import script from "./CatPick.vue?vue&type=script&lang=js&"
export * from "./CatPick.vue?vue&type=script&lang=js&"
import style0 from "./CatPick.vue?vue&type=style&index=0&id=617065b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617065b6",
  null
  
)

export default component.exports